// Simple JavaScript Templating WITH CUSTOM ERROR HANDLING
// John Resig - https://johnresig.com/ - MIT Licensed
export default function tmpl(str, data){
   var fn;
   
   try {
      // Generate a reusable function that will serve as a template
      // generator (and which will be cached).
      fn = new Function("obj",
         "var p=[],print=function(){p.push.apply(p,arguments);};" +

         // Introduce the data as local variables using with(){}
         "with(obj){p.push('" +

         // Convert the template into pure JavaScript
         str.replace(/[\r\t\n]/g, " ")
            .replace(/'(?=[^<%]*((%[^>]|<[^%])[^<%]*)*%>)/g,"\t")
            .split("'").join("\\'")
            .split("\t").join("'")
            .replace(/<%=(.+?)%>/g, "',$1,'")
            .split("<%").join("');")
            .split("%>").join("p.push('")

          + "');}return p.join('');");
   } catch(e) {
      fn = function() { return "Error on template [" + str + "]. " + e };   
   }

   // Provide some basic currying to the user
   return data ? fn( data ) : fn;
};
